<template>
  <div name="lesson_add">

  <transition name="modalwindow">

 <div
        class="modal-mask fixed top-0 left-0 w-full h-full outline-none fade"
      >
        <div
          class="
            relative
            min-h-screen
            flex
            items-center
            justify-center
            py-12
            px-4
            sm:px-6
            lg:px-8
            relative
            items-center
            w-10/12
            mx-auto
          "
        >
          <div class="absolute opacity-60 inset-0 z-0"></div>
          <div
            class="w-full p-6 pb-10 pt-8 bg-white rounded-xl z-10"
          >
            <div class="w-full relative text-right">
              <i
                class="
                  fas
                  fa-times
                  cursor-pointer
                  items-center
                  -mt-4
                  rounded-2
                  text-black text-3xl
                  z-50
                  hover:opacity-75
                "
                @click="$emit('close')"
              ></i>
            </div>

            <div class="text-center">
              <h2 class="text-2xl font-bold text-gray-900">{{title}}</h2>
              <p class="mt-2 text-sm text-gray-400">
                Add a new lesson to your custom unit.
              </p>
            </div>

          <div class="overflow-x-scroll w-full h-screen pb-40">
          <lessonEdit :lesson="lesson" :course="course" :newAddition="true" @append="completeLesson"  :key="lesson.id"></lessonEdit>
          </div>
          
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SchoolService } from "@/services/school.service";

const lessonEdit = () => import("@/components/customunit/TheLessonEdit.vue");

export default {
  name: "lesson_add",
  props: {
    course: Object,
    lesson: Object,
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),

    title() {
      return this.course.name + " New lesson"
    },

  },
  data() {
    return {
      errored: false,
    
    };
  },
  created() {

  },
  mounted() {
  },
  methods: {

    completeLesson() {
        this.$emit('close')
    },

  },
  components: {
    lessonEdit,
  },
};
</script>

<style scoped>

</style>